import { createContext, useContext } from "react";

/**
 * Add new flags here. Every flag needs a static default; FeatureFlagProvider merges the
 * per-environment values from the BFF's /features over these.
 */
export interface FeatureFlags {
  /** Show the Credential Health page + nav item. */
  credentialHealth: boolean;
  /** Show the Alerts page + nav item. Set per environment by the BFF (ALERTS_ENABLED). */
  alerts: boolean;
  /** Show Vulnerability Watch + nav item. Set per environment by the BFF (VULN_WATCH_ENABLED). */
  vulnWatch: boolean;
}

export const FLAG_DEFAULTS: FeatureFlags = {
  credentialHealth: true,
  alerts: false,
  vulnWatch: false,
};

export const FeatureFlagContext = createContext<FeatureFlags>(FLAG_DEFAULTS);

export function useFeatureFlag<K extends keyof FeatureFlags>(flag: K): FeatureFlags[K] {
  return useContext(FeatureFlagContext)[flag];
}

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagContext);
}
